import { produce } from 'immer';

export class StateManagementService {

    constructor(component) {
        this.component = component;
    }

    updateExtractedData(extractedData) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState({extractedData: extractedData}, () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updatePartialCrawlConfigurations(partialCrawlConfigurations) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState({partialCrawlConfigurations: partialCrawlConfigurations}, () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }
    
    updateBatchId(batchId) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState({batchId: batchId}, () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updateLogs(logs) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState({logs: logs}, () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updateProjects(projects) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState({projects: projects}, () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updateJobDefinition(jobDefinition) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    state.extractions = state.extractions.map(extraction => {
                        if (extraction.id == jobDefinition.extraction_id) {
                            return {
                                ...extraction,
                                job_definitions: extraction.job_definitions.map(jd => jd.id == jobDefinition.id ? jobDefinition : jd).sort((a, b) => a.job_reference - b.job_reference)
                            }
                        }
                        return extraction;
                    });
                }), () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updateScriptGenerationRequest(currentJobDefinition, scriptGenerationRequest) {
        // update the script generation request in the job definition with a matching id to the one provided
        let sgrs = currentJobDefinition.script_generation_requests
        if (!sgrs || sgrs.length == 0) {
            sgrs = [scriptGenerationRequest]
        } else {
            sgrs = currentJobDefinition.script_generation_requests.map(sgr => sgr.id == scriptGenerationRequest.id ? scriptGenerationRequest : sgr)
        }
        const updatedJobDefinition = {
            ...currentJobDefinition,
            script_generation_requests: sgrs
        }
        return this.updateJobDefinition(updatedJobDefinition);
    }

    addJobDefinition(jobDefinition) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    const extraction = state.extractions.find(e => e.id === jobDefinition.extraction_id);
                    if (extraction) {
                        // Find the correct insertion index based on job_reference
                        const insertIndex = extraction.job_definitions.findIndex(
                            job => job.job_reference > jobDefinition.job_reference
                        );
                        
                        // If no larger job_reference found, append to end, otherwise insert at index
                        if (insertIndex === -1) {
                            extraction.job_definitions.push(jobDefinition);
                        } else {
                            extraction.job_definitions.splice(insertIndex, 0, jobDefinition);
                        }
                    }
                }), () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    deleteJobDefinition(extractionId, jobDefinitionId) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    const extraction = state.extractions.find(e => e.id === extractionId);
                    if (extraction) {
                        extraction.job_definitions = extraction.job_definitions.filter(j => j.id !== jobDefinitionId);
                    }
                }), () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    addExtraction(extraction) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    // Find the correct insertion index based on name
                    const insertIndex = state.extractions.findIndex(
                        e => e.name.toLowerCase() > extraction.name.toLowerCase()
                    );
                    
                    // If no alphabetically larger name found, append to end, otherwise insert at index
                    if (insertIndex === -1) {
                        state.extractions.push(extraction);
                    } else {
                        state.extractions.splice(insertIndex, 0, extraction);
                    }
                }), () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    updateExtraction(extraction) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    state.extractions = state.extractions.map(x => x.id == extraction.id ? extraction : x).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                }), () => { 
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }

    deleteExtraction(extractionId) {
        return new Promise((resolve, reject) => {
            try {
                this.component.setState(produce(state => {
                    state.extractions = state.extractions.filter(e => e.id !== extractionId);
                }), () => {
                    resolve();
                })
            } catch (error) {
                reject(error);
            }
        });
    }
}